import { motion } from "framer-motion";
import { ClipboardList, FileCheck, Shovel, Construction } from "lucide-react";

const STEPS = [
    {
        num: "01",
        icon: ClipboardList,
        title: "Planning & Survey",
        text: "We visit, measure up and check your kerb, pavement and services. You get one fixed price — no surprises later.",
    },
    {
        num: "02",
        icon: FileCheck,
        title: "Council Permission",
        text: "We handle the entire council application for your dropped kerb — forms, drawings, fees and chasing. You sign nothing but the quote.",
    },
    {
        num: "03",
        icon: Shovel,
        title: "Excavation",
        text: "Our crew excavates to spec, protects utilities and preps the sub-base. Most jobs take just two days on site.",
    },
    {
        num: "04",
        icon: Construction,
        title: "Installation & Finish",
        text: "New kerbs laid, crossing built to council standard, tarmac or block finish rolled smooth. You drive over it the same week.",
    },
];

export default function ProcessManifesto() {
    return (
        <section id="process" className="bg-concrete text-tarmac py-24 sm:py-32" data-testid="process-section">
            <div className="px-5 sm:px-8 max-w-7xl mx-auto">
                <motion.p
                    className="font-mono text-xs tracking-[0.25em] uppercase mb-4"
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.6 }}
                >
                    [ How it works ]
                </motion.p>
                <motion.h2
                    className="font-display uppercase leading-[0.9] tracking-tight text-4xl sm:text-5xl lg:text-7xl mb-6"
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7 }}
                >
                    We handle everything.<br />
                    <span className="text-tarmac/40">Start to smooth finish.</span>
                </motion.h2>
                <div className="road-line w-full mb-16" />

                <div className="grid grid-cols-1 md:grid-cols-2 border-t border-l border-tarmac/20">
                    {STEPS.map((step, i) => (
                        <motion.article
                            key={step.num}
                            data-testid={`process-step-${step.num}`}
                            className="group relative border-b border-r border-tarmac/20 p-8 sm:p-12 hover:bg-tarmac hover:text-paper transition-colors duration-300"
                            initial={{ opacity: 0, y: 32 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.6, delay: i * 0.1 }}
                        >
                            <div className="flex items-start justify-between mb-10">
                                <span className="font-mono text-6xl sm:text-7xl font-bold text-tarmac/15 group-hover:text-amber transition-colors duration-300">
                                    {step.num}
                                </span>
                                <step.icon size={28} className="text-tarmac/40 group-hover:text-amber transition-colors duration-300" />
                            </div>
                            <h3 className="font-display uppercase text-2xl sm:text-3xl mb-4 tracking-tight">
                                {step.title}
                            </h3>
                            <p className="text-base text-tarmac/70 group-hover:text-grit leading-relaxed max-w-md transition-colors duration-300">
                                {step.text}
                            </p>
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
}
